import { IconButton, TableCell, TableRow, TextField } from "@material-ui/core";
import React, { useState } from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import ConfirmationDialogActions from "../../Shared/ConfirmationDialogActions";

const BoxesTableRow = ({
  box,
  handleUpdateLocalBox,
  index,
  handleConfirmBoxDeletion,
}) => {
  const [openDeleteConfirmationDialog, setOpenDeleteConfirmationDialog] =
    useState(false);

  return (
    <>
      {openDeleteConfirmationDialog && (
        <ConfirmationDialogActions
          title={"Are you sure?"}
          open={openDeleteConfirmationDialog}
          contentText={`This action will permanently remove the box from the system. Are you sure you want to proceed?`}
          button1Action={() => setOpenDeleteConfirmationDialog(false)}
          button1Text={"Cancel"}
          button2Text={"Confirm"}
          button2Action={() => handleConfirmBoxDeletion(box?.id)}
        />
      )}
      <TableRow
        className={` ${
          index % 2 === 0 ? "products-table-even-row" : "products-table-odd-row"
        } `}
      >
        <TableCell
          className={`products-table-cell ${
            index % 2 === 0
              ? "products-table-even-cell"
              : "products-table-odd-cell"
          }`}
        >
          <TextField
            size="small"
            value={box.name}
            fullWidth
            onChange={(e) => {
              handleUpdateLocalBox("name", e.target.value, box?.id);
            }}
            InputLabelProps={{ shrink: true }}
          />
        </TableCell>

        <TableCell className="products-table-cell">
          <TextField
            size="small"
            value={box.height}
            fullWidth
            onChange={(e) => {
              const value = e.target.value || 1;
              if (/^\d*\.?\d*$/.test(value)) {
                handleUpdateLocalBox("height", value, box?.id);
              }
            }}
            InputLabelProps={{ shrink: true }}
            inputProps={{ pattern: "\\d*\\.?\\d*" }}
          />
        </TableCell>

        <TableCell className="products-table-cell">
          <TextField
            size="small"
            value={box.width}
            fullWidth
            onChange={(e) => {
              const value = e.target.value || 1;
              if (/^\d*\.?\d*$/.test(value)) {
                handleUpdateLocalBox("width", value, box?.id);
              }
            }}
            InputLabelProps={{ shrink: true }}
            inputProps={{ pattern: "\\d*\\.?\\d*" }}
          />
        </TableCell>

        <TableCell className="products-table-cell">
          <TextField
            size="small"
            value={box.length}
            fullWidth
            onChange={(e) => {
              const value = e.target.value || 1;
              if (/^\d*\.?\d*$/.test(value)) {
                handleUpdateLocalBox("length", value, box?.id);
              }
            }}
            InputLabelProps={{ shrink: true }}
            inputProps={{ pattern: "\\d*\\.?\\d*" }}
          />
        </TableCell>

        <TableCell className="products-table-cell">
          <TextField
            size="small"
            value={box.minCapacity}
            fullWidth
            onChange={(e) => {
              const value = e.target.value || 1;
              if (/^\d*\.?\d*$/.test(value)) {
                handleUpdateLocalBox("minCapacity", value, box?.id);
              }
            }}
            InputLabelProps={{ shrink: true }}
            inputProps={{ pattern: "\\d*\\.?\\d*" }}
          />
        </TableCell>
        <TableCell className="products-table-cell">
          <TextField
            size="small"
            value={box.maxCapacity}
            fullWidth
            onChange={(e) => {
              const value = e.target.value || 1;
              if (/^\d*\.?\d*$/.test(value)) {
                handleUpdateLocalBox("maxCapacity", value, box?.id);
              }
            }}
            InputLabelProps={{ shrink: true }}
            inputProps={{ pattern: "\\d*\\.?\\d*" }}
          />
        </TableCell>

        <TableCell className="products-table-cell">
          <IconButton aria-label="settings">
            <DeleteIcon
              onClick={(e) => setOpenDeleteConfirmationDialog(true)}
            />
          </IconButton>
        </TableCell>
      </TableRow>
    </>
  );
};

export default BoxesTableRow;
